module.exports = __webpack_public_path__ + "kickstand.png";